module.exports = "../../app/cells/components/campaigns/interventions/top_bar_cell.rb";